import { render } from "./TradeInSettings.vue?vue&type=template&id=ea24722e"
import script from "./TradeInSettings.vue?vue&type=script&lang=js"
export * from "./TradeInSettings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__